<script>
  // Перенос Jc из parts.tsx — сумма в JC со значком монеты.
  import Ico from '../ico.svelte';
  import { num } from '../partsfn.js';
  export let v = 0;
  export let s = 14;
</script>

<span class="mn-ico-txt mn-num"><Ico n="currency" {s} />{num(v)}</span>
